'use strict';

import Vue from 'vue';
import {getBasketItemsCount} from '../api/other';

export const state = Vue.observable({
    count: 0,
});

export async function update() {
    const count = await getBasketItemsCount();

    state.count = count;
}

document.addEventListener('DOMContentLoaded', update);
